/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditVariantDto } from '../../models/backend-credit-variant-dto';
import { BackendCreditVariantRequestDto } from '../../models/backend-credit-variant-request-dto';

export interface FinancingSourcesCreditsVariantsCreate$Params {
  body: BackendCreditVariantRequestDto;
}

export function financingSourcesCreditsVariantsCreate(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsVariantsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsVariantsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditVariantDto>;
    }),
  );
}

financingSourcesCreditsVariantsCreate.PATH = '/api/financing_sources/credits_variants/';
